import urljoin from 'url-join';
import { EmbedConfig } from '../..';
import render from '../../designs/paper';

import AvenirNextLTProWoff2 from '../../../../../../client/assets/AvenirNextLTPro-Demi.woff2';

import './styles/style.scss';

const additionalFonts = (config: EmbedConfig) => {
  const avenirNextLTProWoff2Path = urljoin(config.goBaseUrl, AvenirNextLTProWoff2);

  return `
    @font-face {
      font-family: 'Avenir Next LT Pro';
      font-style: normal;
      src: url('${avenirNextLTProWoff2Path}') format('woff2');
    }`;
};

render(additionalFonts);
